import { render, staticRenderFns } from "./WeekdaysStatsTable.vue?vue&type=template&id=2a099d0d&scoped=true&"
import script from "./WeekdaysStatsTable.vue?vue&type=script&lang=js&"
export * from "./WeekdaysStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a099d0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
